// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastSchema = z.object({
  id: z.number().int().describe("Unique identifier for the task"),
  note: z.coerce.string().describe("Task note (same as title, for backwards compatibility)"),
  title: z.coerce.string().describe("Task title"),
  description: z.coerce.string().describe("Detailed description of the task").nullish(),
  from: z.coerce.string().describe("Start date in ISO 8601 format"),
  to: z.coerce.string().describe("End date in ISO 8601 format"),
  user: z.object({
    id: z.nullable(z.number().int()),
    email: z.coerce.string(),
    name: z.coerce.string(),
    avatar: z.object({
      large_retina: z.nullable(z.coerce.string()),
      large: z.nullable(z.coerce.string()),
      medium_retina: z.nullable(z.coerce.string()),
      medium: z.nullable(z.coerce.string()),
      timeline: z.nullable(z.coerce.string()),
    }),
    updated_at: z.nullable(z.coerce.string()),
    estimated_minutes: z.optional(z.number().int()),
    estimated_duration: z.optional(z.object({
      hours: z.number().int(),
      minutes: z.number().int(),
      seconds: z.number().int(),
      formatted: z.coerce.string().min(1),
      total_hours: z.number(),
      total_seconds: z.number().int(),
      total_minutes: z.number().int(),
    })),
    weekly_capacity: z.optional(z.number()),
    work_days: z.coerce.string().nullish(),
    weekdays: z.coerce.string().nullish(),
  }).describe("Primary user assigned to the task").nullish(),
  users: z.array(z.object({
    id: z.nullable(z.number().int()),
    email: z.coerce.string(),
    name: z.coerce.string(),
    avatar: z.object({
      large_retina: z.nullable(z.coerce.string()),
      large: z.nullable(z.coerce.string()),
      medium_retina: z.nullable(z.coerce.string()),
      medium: z.nullable(z.coerce.string()),
      timeline: z.nullable(z.coerce.string()),
    }),
    updated_at: z.nullable(z.coerce.string()),
    estimated_minutes: z.optional(z.number().int()),
    estimated_duration: z.optional(z.object({
      hours: z.number().int(),
      minutes: z.number().int(),
      seconds: z.number().int(),
      formatted: z.coerce.string().min(1),
      total_hours: z.number(),
      total_seconds: z.number().int(),
      total_minutes: z.number().int(),
    })),
    weekly_capacity: z.optional(z.number()),
    work_days: z.coerce.string().nullish(),
    weekdays: z.coerce.string().nullish(),
  })).describe("All users assigned to the task"),
  project: z.object({
    id: z.number().int(),
    active: z.boolean(),
    name: z.coerce.string(),
    color: z.coerce.string(),
    client: z.object({
      id: z.number().int(),
      name: z.coerce.string(),
      color: z.coerce.string(),
      active: z.boolean(),
      external_id: z.coerce.string().nullish(),
      updated_at: z.coerce.string(),
    }),
    updated_at: z.coerce.string(),
  }).describe("Project this task belongs to"),
  estimated_minutes: z.number().int().describe("Estimated time in minutes"),
  updated_at: z.coerce.string().describe("ISO 8601 timestamp of last modification"),
  created_at: z.coerce.string().describe("ISO 8601 timestamp when task was created"),
  label_ids: z.array(z.number().int()).describe("Tags/categories applied to this task"),
  estimated_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Estimated duration for the task"),
  planned_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Planned duration for the task"),
  logged_duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Time already logged against this task"),
  completed: z.boolean().describe("Whether the task is marked as completed"),
  completed_at: z.coerce.string().describe("ISO 8601 timestamp when task was completed").nullish(),
  manage: z.boolean().describe("True if current user can edit/delete this task"),
  external_id: z.coerce.string().describe("Your system's identifier for integration mapping").nullish(),
  parent_title: z.coerce.string().describe("Title of the parent task (for subtasks)").nullish(),
});
